import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AdvisorBusinessInfoModel} from '@models/api/advisor/advisor-business-info.model';
import {CompetencyStatusModel} from '@models/api/advisor/competency-status.model';
import {environment} from 'environments/environment';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ApiAdvisorService {

    public static readonly COMPETENCY_CODE_HYPO = 'Hypo';

    constructor(
        private httpClient: HttpClient,
    ) {
    }

    /**
     * Get advisor business info
     * @param advisorId
     */
    public getAdvisorBusinessInfo(advisorId: number): Observable<AdvisorBusinessInfoModel> {
        return this.httpClient
            .get<AdvisorBusinessInfoModel>(`${environment.ApolloApiUrl}/Advisor/${advisorId}/BusinessInfo`);
    }

    /**
     * Get Advisor competency status
     * @param advisorId
     */
    public getCosultancyCompetencyStatus(advisorId: number, code: string): Observable<CompetencyStatusModel[]> {
        return this.httpClient
            .get<CompetencyStatusModel[]>(`${environment.ApolloApiUrl}/Advisor/${advisorId}/CosultancyCompetencyStatus?codes=${code}`);
    }

}
